<template>
  <div>
    <div class="container pd">
      <div class="bg-container" :style="{ background: Color }">
        <div class="flex">
          <h3>
            {{ title }}
          </h3>
          <h5>{{ subtitle }}</h5>
          <div class="outer">
            <div class="grid">
              <div>
                <a href="http://m.me/upskillbd" target="_blank">
                  <img
                    src="../../assets/chaldal/Icon awesome-facebook-messenger.svg"
                    alt=""
                  />
                </a>
                <h2>
                  Messenger
                </h2>
              </div>
              <div>
                <a
                  href="mailto:upskill@upskillbangladesh.com?subject=Want to work as a Instructor"
                  target="_blank"
                >
                  <img
                    src="../../assets/chaldal/Icon simple-google.svg"
                    alt=""
                  />
                </a>
                <h2>
                  mail
                </h2>
              </div>

              <div>
                <a href="https://wa.me/+8801714053213" target="_blank">
                  <img
                    src="../../assets/chaldal/Icon ionic-logo-whatsapp.svg"
                    alt=""
                  />
                </a>
                <h2>
                  WhatsApp
                </h2>
              </div>
              <div>
                <a href="tel:+8801714053213">
                  <img
                    src="../../assets/chaldal/call.svg"
                    target="_blank"
                    alt=""
                  />
                </a>
                <h2>
                  Call
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    Color: String,
  },
}
</script>

<style scoped>
.bg-container {
  border-radius: 10px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 15px;

  margin-bottom: 75px;
}
.grid > :nth-child(n) {
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.grid img {
  margin-top: 35px;
  justify-self: center;
}
.pd {
  padding: 0;
  margin-bottom: 120px;
}
.flex-1 {
  width: 100%;
}
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.flex h3 {
  font: 700 3rem/3rem 'Open Sans';
  text-align: center;
  letter-spacing: -2.4px;
  padding-top: 76px;
  color: #ffffff;
}

h2 {
  text-transform: capitalize;
  font: 700 1.125rem/1.5rem 'Open Sans';
  text-align: center;
  letter-spacing: 0;
  padding-top: 21px;
  color: #ffffff;
}
.flex h5 {
  padding: 0 190px;
  font: 400 1.25rem/1.75rem 'Open Sans';
  text-align: center;
  letter-spacing: 0;
  padding-top: 25px;
  color: #ffffff;
}
@media only screen and (min-width: 1300px) {
  .container {
    max-width: 1300px !important;
  }
}

@media only screen and (max-width: 600px) {
  .bg-container {
    border-radius: 0px;
  }
  .flex h5 {
    display: none;
    padding: 0 190px;
    font: 400 1.25rem/1.75rem 'Open Sans';
    text-align: center;
    letter-spacing: 0;
    padding-top: 25px;
    color: #ffffff;
  }
  .outer {
    min-width: 100%;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 5px;

    margin-bottom: 25px;
    padding: 0px;
    place-items: center;
  }
  .grid > :nth-child(n) {
    margin-top: 0px;
    min-height: 100px;
  }
  .pd {
    padding: 0 0px;
    margin-bottom: 0px;
  }
  .flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .flex h3 {
    text-align: center;
    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
    padding-top: 50px;
  }
  .flex h1 {
    text-transform: uppercase;
    font-family: 'Open Sans';
    font-size: 60px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 24px;
    color: #ffc600;
    padding-top: 50px;
    padding-bottom: 100px;
  }
}
</style>
